var map = {
	"./aneurysm.webp": 2476,
	"./atrophy.webp": 8785,
	"./built to break.webp": 4282,
	"./complete and total breakdown.webp": 7503,
	"./death to us.webp": 7329,
	"./december.webp": 8443,
	"./heavy.webp": 1647,
	"./i cant breathe but i feel so warm inside.webp": 1615,
	"./nobody.webp": 8991,
	"./space waster.webp": 6586,
	"./that sinking feeling.webp": 528,
	"./yeah whatever.webp": 1019
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6172;